'use client';
import { Loader } from '@bridebook/aura/src/icons';
import { cn } from '../../lib/utils/cn';
import { Icon } from '../icon/icon';

export function Spinner({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span role="status" aria-label="Loading" className={cn('inline-flex', className)} {...props}>
      <Icon icon={Loader} className="size-4 animate-spin" />
    </span>
  );
}
